import PropTypes from "prop-types";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toastSuccess } from "../../../shared/toastHelper";

const CheckoutEmbedSnippet = ({ step, instructions, rows, code, copyLabel }) => (
  <div className="checkout-embed-step">
    <p className="setlist-text-sm setlist-font-semibold text-dark mb-1">
      {step}. {instructions}
    </p>
    <textarea className="form-control checkout-embed-code" rows={rows} readOnly value={code} />
    <div className="text-right mt-2">
      <CopyToClipboard options={{ format: 'text/plain' }} text={code} onCopy={() => toastSuccess("Copied to clipboard")}>
        <button type="button" className="btn btn-sm btn-setlist-secondary">
          {copyLabel}
        </button>
      </CopyToClipboard>
    </div>
  </div>
);

CheckoutEmbedSnippet.propTypes = {
  step: PropTypes.number.isRequired,
  instructions: PropTypes.node.isRequired,
  rows: PropTypes.number.isRequired,
  code: PropTypes.string.isRequired,
  copyLabel: PropTypes.string.isRequired,
};

export default CheckoutEmbedSnippet;
